// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import { stringify } from 'query-string';

import useRouter from 'Hooks/useRouter';
import OffersFilter from 'Components/Filters/OffersFilter';
import AvailabilityFilter from 'Components/Filters/AvailabilityFilter';
import StockLocationFilter from 'Components/Filters/StockLocationFilter';

const AvailabilityFilters = () => {
  const { push, location, query } = useRouter();
  const [availableOpen, setAvailableOpen] = useState(true);
  const [stockLocationOpen, setStockLocationOpen] = useState(true);
  const [offersOpen, setOffersOpen] = useState(true);

  const handleOnSetOffersOpen = () => { setOffersOpen(!offersOpen); };
  const handleOnSetStockLocationOpen = () => { setStockLocationOpen(!stockLocationOpen); };
  const handleOnSetAvailabilitiesOpen = () => { setAvailableOpen(!availableOpen); };

  const handleAvailabilityChange = newSelection => checked => {
    const newQuery = { ...query };
    if (newSelection === 'promotions') {
      if (checked) {
        newQuery.only_promotional = 1;
      } else {
        delete newQuery.only_promotional;
      }
      delete newQuery.only_resealed;
      delete newQuery.stock_clearing_sale;
    }
    if (newSelection === 'resealed') {
      if (checked) {
        newQuery.only_resealed = 1;
      } else {
        delete newQuery.only_resealed;
      }
      delete newQuery.only_promotional;
      delete newQuery.stock_clearing_sale;
    }
    if (newSelection === 'clearance') {
      if (checked) {
        newQuery.stock_clearing_sale = 1;
      } else {
        delete newQuery.stock_clearing_sale;
      }
      delete newQuery.only_promotional;
      delete newQuery.only_resealed;
    }
    delete query.page;
    // if (newSelection === 'eol') {
    // }
    push({
      pathname: location.pathname,
      search: stringify(newQuery)
    });
  };

  const handleStockChange = checked => {
    if (checked) {
      query.only_available = 1;
    } else {
      delete query.only_available;
    }
    delete query.page;
    push({
      pathname: location.pathname,
      search: stringify(query)
    });
  };

  const handleReservedStockChange = checked => {
    if (checked) {
      query.only_available = 1;
      query.include_reserved_stock = 1;
    } else {
      delete query.include_reserved_stock;
    }
    delete query.page;
    push({
      pathname: location.pathname,
      search: stringify(query)
    });
  };

  const handleOnlyWarehouseChange = checked => {
    if (checked) {
      query.only_warehouse_products = 1;
    } else {
      delete query.only_warehouse_products;
    }
    delete query.page;
    push({
      pathname: location.pathname,
      search: stringify(query)
    });
  };

  return (
    <>
      <AvailabilityFilter
        open={ availableOpen }
        onToggle={ handleOnSetAvailabilitiesOpen }
        onStockChange={ handleStockChange }
        onReservedStockChange={ handleReservedStockChange }
        inStock={ !!query.only_available }
        inStockReserved={ !!query.include_reserved_stock }
      />
      <StockLocationFilter
        open={ stockLocationOpen }
        onToggle={ handleOnSetStockLocationOpen }
        onOnlyWarehouseChange={ handleOnlyWarehouseChange }
        onlyWarehouse={ !!query.only_warehouse_products }
      />
      <OffersFilter
        open={ offersOpen }
        onToggle={ handleOnSetOffersOpen }
        onAvailabilityChange={ handleAvailabilityChange }
        availability={{
          /* eslint-disable */
          resealed: query.only_resealed == 1,
          promotions: query.only_promotional == 1,
          clearance: query.stock_clearing_sale == 1,
          reserved: query.include_reserved_stock == 1
          /* eslint-enable */
        }}
      />
    </>
  );
};

export default AvailabilityFilters;
